// client/src/components/Store.jsx

import { Navbar, Footer } from './react-public';
import StoreList from './react-public/features/StoreList';
import styles from '../style';

// <CatalogCarousel />

const Store = () => {
  return (
    <div className="bg-primary w-full min-h-screen">
      <div className={`${styles.paddingX} ${styles.flexCenter}`}>
        <div className={`${styles.boxWidth}`}>
          <Navbar />
        </div>
      </div>

      <div className={`bg-primary ${styles.flexStart}`}>
        <div className={`${styles.boxWidth}`}>
          <StoreList />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Store;